import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PasswordResetStateService {
  private readonly identifierKey = 'password-reset-identifier';

  save(identifier: string): void {
    sessionStorage.setItem(this.identifierKey, identifier);
  }

  get(): string {
    return sessionStorage.getItem(this.identifierKey) ?? '';
  }

  clear(): void {
    sessionStorage.removeItem(this.identifierKey);
  }
}
